var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-notification',{class:_vm.$style.loadingContainer,attrs:{"closable":false}},[_c('b-loading',{attrs:{"is-full-page":false,"active":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }